import MixedEvaluationModal from './MixedEvaluationModal'

export default MixedEvaluationModal
